import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFileTypesCount = createSelector(
  [(store: RootState) => store.fileTypes.fileTypesList],
  (data) => data.length
);